import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Waiting from '../../layout/Waiting.jsx';
import { logoutService } from '../../services/authServices.js';
import Alert from '../../utils/Alert.js';
import { useDispatch } from 'react-redux';

const Logout = () => {
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();

    const handleLogout = async () => {
        setIsLoading(true);
        try {
            const response = await logoutService();
            if (response.status === 200) {
                localStorage.removeItem("cncToken");
                dispatch({ type: "GET_LOGIN_ERR" });
            }
        } catch (error) {
            await Alert(`خطا ${error.response ? error.response.status : ""}!`, "مشکلی رخ داده است لطفا مجدداً تلاش کنید.", "error")
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        handleLogout();
    }, []);

    return isLoading ? (
        <Waiting />
    ) : (
        <Navigate to="/auth/login" />
    );
}

export default Logout;
